import { render } from "./CorporatePlanCarbonTracker.vue?vue&type=template&id=66c58622"
import script from "./CorporatePlanCarbonTracker.vue?vue&type=script&lang=js"
export * from "./CorporatePlanCarbonTracker.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__